import { useContext } from 'react'
import { FrameDetectionContext } from '../../modules/App/Providers/FrameDetection'

const useIsIFramed = () => useContext(FrameDetectionContext)

export { useIsIFramed }
